import { compose } from '@reduxjs/toolkit';
import { fetchAllPriceGroupsReducer } from './fetchPriceGroups';

export const extraReducers = compose(fetchAllPriceGroupsReducer);
export { fetchAllPriceGroups } from './fetchPriceGroups';
